import { useQuery } from 'react-query'
import request from '../../request'
import { User } from '../../../lib/types/User'
import { useDealership } from '../../../store/zustand/dealershipStore'

export const useGetUserDealerships = (user_id: number | string | undefined) => {
  const dealership = useDealership()

  return useQuery<
    {
      has_all_dealership_access: boolean
      dealerships?: Array<{ dealership_id: number }>
    },
    Error
  >(
    [dealership?.organization_id, 'user', 'dealerships', user_id],
    () =>
      request({
        url: `/agencies/${dealership?.organization_id}/users/${user_id}/dealerships`,
        method: 'GET',
      }).then((res: any) => res.data),
    {
      enabled: !!user_id,
    },
  )
}
